import React, { FC, ReactNode } from 'react';
import { ModalProps, Modal as RNModal, View } from 'react-native';
import styled from 'styled-components/native';

import { isRTL } from '@webtrader/core/i18n';

import ModalHeader from './Header';

interface IProps {
  title?: ReactNode;
  suffix?: ReactNode;
  visible?: boolean;
  description?: string;
  onClose?: () => void;
}

const CustomModal: FC<IProps & ModalProps> = (props) => {
  const { title, suffix, visible, description, animationType = 'slide', onClose, children, ...restProps } = props;

  return (
    <RNModal
      {...restProps}
      visible={visible}
      animationType={animationType}
      supportedOrientations={['landscape', 'portrait']}
      dir={isRTL() ? 'rtl' : 'ltr'}
    >
      <ModalSafeAreaView>
        <ModalHeader title={title} suffix={suffix} description={description} onClose={onClose} />
        <ModalContent>{children}</ModalContent>
      </ModalSafeAreaView>
    </RNModal>
  );
};

export default CustomModal;

const ModalSafeAreaView = styled.SafeAreaView`
  flex: 1;
  background-color: ${({ theme }) => theme.colors.background[0]};
`;

const ModalContent = styled(View)`
  flex: 1;
`;
